import { FeedbackService } from './../../../shared/services/feedback.service';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IFeedback } from '../../../_models/cms/IFeedback';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css']
})
export class FeedbackComponent implements OnInit {
  loading: boolean;
  title: string = 'Add Feedback';
  feedback: IFeedback;
  feedbackForm: FormGroup;
  id;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private service: FeedbackService) {
  }

  ngOnInit() {
    this.createFeedbackForm();
  }

  createFeedbackForm() {
    this.feedbackForm = this.fb.group({
      id: ['0', Validators.required],
      name: ['', Validators.required],
      emailId: ['', Validators.required],
      mobileNo: [''],
      message: ['', Validators.required]
    });
  }

  save() {
    if (this.feedbackForm.valid) {
      this.loading = true;
      this.feedback = Object.assign({}, this.feedbackForm.value);
      this.service.create(this.feedback).subscribe(() => {
        this.toastrService.success('Your feedback has been sent successfully.');
        this.feedbackForm.reset();
      },
        (error) => console.log('HTTP Error', error),
        () => this.loading = false);
    }
  }
}
